module.exports = __webpack_public_path__ + "static/img/book4.aa484350.jpg";